/* eslint-disable no-console */
<template>

    <div class="main_unit">
        <pulse-loader class="w-100 text-center" :loading="isInitLoading"></pulse-loader>
        <div v-show="!isInitLoading">
            <div class="admin_menu_top_unit menu_center">
                <form class="form_companyBrand">
                    <div class="lavel_companyBrand right_comment">
                        <label for="companyid">企業コード</label>
                    </div>
                    <div class="input_companyBrand left_comment">
                        <label id="companyid" name="companyid">{{brand.brandId}}</label>
                    </div>

                    <div class="lavel_companyBrand right_comment">
                        <label for="companyname">企業名</label>
                    </div>
                    <div class="input_companyBrand left_comment">
                        <label id="companyname" name="companyname">{{brand.companyName}}</label>
                    </div>

                    <div class="lavel_companyBrand right_comment">
                        <label for="companyurl">URL</label>
                    </div>
                    <div class="input_companyBrand left_comment">
                        <label id="companyurl" name="companyurl">{{brand.url}}</label>
                    </div>

                    <div class="lavel_companyBrand right_comment">
                        <label for="companybrandname">ブランド名</label>
                    </div>
                    <div class="input_companyBrand left_comment">
                        <label id="companybrandname" name="companybrandname">{{brand.brandName}}</label>
                    </div>

                    <div class="lavel_companyBrand right_comment">
                        <label for="companypostalcode">郵便番号</label>
                    </div>
                    <div class="input_companyBrand left_comment">
                        <label id="companypostalcode" name="companypostalcode">{{brand.zipCode}}</label>
                    </div>

                    <div class="lavel_companyBrand right_comment">
                        <label for="companyaddress">企業住所</label>
                    </div>
                    <div class="input_companyBrand left_comment">
                        <label id="companyaddress" name="companyaddress">{{brand.address}}</label>
                    </div>

                    <div class="lavel_companyBrand right_comment">
                        <label for="companydepartmentname">担当部署</label>
                    </div>
                    <div class="input_companyBrand left_comment">
                        <label id="companydepartmentname" name="companydepartmentname">{{brand.departmentName}}</label>
                    </div>

                    <div class="lavel_companyBrand right_comment">
                        <label for="companyｒemarks">備考欄</label>
                    </div>
                    <div class="input_companyBrand left_comment">
                        <label id="companyｒemarks" name="companyｒemarks">{{brand.remarks}}</label>
                    </div>

                    <div class="lavel_companyBrand right_comment">
                        <label for="companytell">連絡先電話番号</label>
                    </div>
                    <div class="input_companyBrand left_comment">
                        <label id="companytell" name="companytell">{{brand.phoneNumber}}</label>
                    </div>
                </form>
                <div class="password_init">
                    <input role="button" id="arrangement4" @click="openModel" value="パスワード初期化">
                </div>
            </div>
        </div>
        <div class="overlay" v-if="showContent">
            <div>
                <div class="modal_box wd512">
                    <div class="modal_header_unit">
                        <div class="modal_header_box">
                            <p class="modal_header_tit">企業管理者パスワード初期化</p>
                        </div>
                    </div>
                    <div class="modal_content_tex">
                        <p>企業管理者パスワードを初期化します。<br>
                            よろしいですか？<br>
                            企業名：{{brand.companyName}}
                        </p>
                    </div>
                    <div class="btn_submit_box">
                        <div class="btn_submit2">
                            <a href="#" @click.stop.prevent="closeModel">キャンセル</a>
                        </div>
                        <div class="btn_submit">
                            <a href="#" @click.stop.prevent="delModel">パスワード初期化</a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="overlay" v-if="showContent2">
            <div>
                <div class="modal_box wd512">
                    <div class="modal_header_unit">
                        <div class="modal_header_box">
                            <p class="modal_header_tit">企業管理者パスワード初期化</p>
                        </div>
                    </div>
                    <div class="modal_content_tex">
                        <p>パスワード初期化が完了しました。<br>
                            新しいパスワードを企業管理者に通知してください。<br>
                            新しいパスワード：{{password}}
                        </p>
                    </div>

                    <div class="btn_submit_box">
                        <div class="btn_submit">
                            <a href="#" @click.prevent.stop="closeModel2()">OK</a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="overlay_loder" v-show="isLoading">
            <pulse-loader class="w-100 text-center" :loading="isLoading"></pulse-loader>
        </div>

    </div>
</template>

<script>
    import PulseLoader from '@/app/components/PulseLoader.vue'
export default {
    name: 'CommpanyBraindDitail',
    components: {
        PulseLoader
    },
    props:{
        id:Number,
    },
    data: function () {
        return {
            ApivalidationMessage:'',
            isLoading:false,
            isInitLoading:true,
            password: '',
            showContent: false,
            showContent2: false,
            brand: {}
        }
    },
    computed:{
        brandPath: function () {
            // $routeから取得
            return this.$route.params.brandPath
        },
        selectedId() {
            this.id
            return this.id == null ? this.$store.getters['brand/selectedBrandId'] : this.id;
        }
    },
    created: function(){
        this.calc();
    },
    methods:{
        async calc(){
            // 店舗情報の取得
            await this.$axios
                .get(this.$apiEndpoint + 'manage/brand/' + this.selectedId)
                .then(response => (this.brand = response['data']['brand']))
                .catch((err) => {
                    let error = {
                        button: {
                            path: {name: 'top', params:{brandPath: this.brandPath}}
                        }}
                    if (err.customError) {
                        error = Object.assign(error, err.customError)
                    }
                    this.$store.dispatch('error/setError', error).then(this.$router.push({name: 'error'}))
                }).finally(()=> this.isInitLoading = false);

        },
        openModel() {
            this.showContent = true;
        },
        closeModel() {
            this.showContent = false;
        },
        closeModel2() {
            this.showContent2 = false;
            this.password = ''
        },
        async delModel() {

            // 初期化
            this.showContent = false;
            this.isLoading = true;
            this.ApivalidationMessage = '';

            // APIフラグオン
            var apiResponseFlg = true;

            // パスワード初期化API
            await this.$axios
                .post(this.$apiEndpoint + 'manage/brand/' + this.selectedId + '/password_init', {
                    brand_id: this.selectedId,
                })
                .then(response => (this.password = response['data']['manager'].password))
                .catch((err) => {
                    let error = {
                        button: {
                            path: {name: 'top', params:{brandPath: this.brandPath}}
                        }}
                    apiResponseFlg = false;
                    if (err.customError) {
                        error = Object.assign(error, err.customError);

                        if(error.code == 400){
                            this.ApivalidationMessage =  error.message;
                        }
                    }
                    if(error.code !== 400){
                        this.$store.dispatch('error/setError', error).then(this.$router.push({name: 'error'}))
                    }
                }).finally(()=> this.isLoading = false);

            if(apiResponseFlg){
                this.showContent2 = true
            }
        },
    }
}
</script>